import { Link } from 'react-router-dom'

export function Home() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <h1 className="text-4xl font-bold tracking-tight">
        OnlyBans
      </h1>
      <p className="mt-4 text-lg text-zinc-400">
        一键屏蔽 X (Twitter) 上的黄推机器人。订阅 OnlyBans
        维护的黑名单数据库，让你的评论区清净。
      </p>
      <div className="mt-8 flex gap-3">
        <Link
          to="/login"
          className="inline-flex items-center rounded-md bg-zinc-100 px-4 py-2 text-sm font-medium text-zinc-900 hover:bg-white"
        >
          登录 / 注册
        </Link>
        <Link
          to="/dashboard"
          className="inline-flex items-center rounded-md border border-zinc-700 px-4 py-2 text-sm text-zinc-300 hover:bg-zinc-900"
        >
          仪表盘
        </Link>
      </div>
    </div>
  )
}
